import api from "../../../api";

export default {
  async getAlerts({ commit }) {
    commit("REQUEST_ALERTS");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_ALERTS",
        await api.getAlerts()
      );
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_ALERTS");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async deleteAlert({ commit }, id) {
    commit("REQUEST_DELETE_ALERT");
    commit("SET_LOADING", true, { root: true });
    try {
      await api.deleteAlert(id);
      commit("SUCCESS_DELETE_ALERT", id);
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_DELETE_ALERT");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  }


};
